export * from './spinner'
export * from './status-spinner'
import spinner from './spinner'
export default spinner
